import {Button} from "@mui/material";
import {grey} from "@mui/material/colors";

export const SubmitButton = ({sx = {}, children, ...props}) => (
  <Button variant={"contained"} color={"success"}
          sx={{px: 3, textTransform: 'capitalize', ...sx}}
          {...props}
  >
    {children || "Submit"}
  </Button>
)